import { render, staticRenderFns } from "./ModalRoles.vue?vue&type=template&id=7139e8f0&scoped=true"
import script from "./ModalRoles.vue?vue&type=script&lang=js"
export * from "./ModalRoles.vue?vue&type=script&lang=js"
import style0 from "./ModalRoles.vue?vue&type=style&index=0&id=7139e8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139e8f0",
  null
  
)

export default component.exports